import { render, staticRenderFns } from "./HaAccommodationsEdit.vue?vue&type=template&id=6ec2f80f&scoped=true&"
import script from "./HaAccommodationsEdit.vue?vue&type=script&lang=js&"
export * from "./HaAccommodationsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec2f80f",
  null
  
)

export default component.exports